import { KnmRegistryActionsEnum } from '../enums/KnmRegistryActionsEnum';
import { IKnmRegistryState } from '../interfaces/IKnmRegistryState';
import { KnmRegistryAction } from '../type/KnmRegistryAction';

const initial: IKnmRegistryState = {
  data: [],
};

export function knmRegistryReducer(state = initial, action: KnmRegistryAction) {
  switch (action.type) {
    case KnmRegistryActionsEnum.KNM_REGISTRY_SET_DATA: {
      const newState: IKnmRegistryState = {
        ...state,
        data: action.payload.data,
      };

      return newState;
    }
    default:
      return state;
  }
}
